import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';

export const LazyLoadedMonogramView = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/website/header/monogramview" */ './MonogramView'),
  'MonogramView',
);
